
const initialState = {
    data:[],
    loading:false,
    saving:false,
    deletingId: null,
    error:null,

    objectives: { loading: false, saving: false,  error: null },

    matrix:{
      data:[],
      loading:false,
      error:null
    },
    matrixPei:{
      data:null,
      loading:false,
      error:null
    }
  };
    
  const peiReducer = (state = initialState, action) => {
  
    switch (action.type) {
      case 'LOAD_PEI_REQUEST':
        return { ...state, loading: true, error: null};
      case 'LOAD_PEI_SUCCESS':
        return { ...state, loading: false, data: action.payload, error: null};
      case 'LOAD_PEI_FAIL':
        return { ...state, loading: false, error: action.payload };
      
      case 'SAVE_PEI_REQUEST':
        return { ...state, saving: true, error: null};
      case 'SAVE_PEI_SUCCESS':
        return { ...state, saving: false, error: null};
      case 'SAVE_PEI_FAIL':
        return { ...state, saving: false, error: action.payload };

      case 'UPDATE_PEI_STATUS_REQUEST':
        return { ...state, saving: true, error: null};
      case 'UPDATE_PEI_STATUS_SUCCESS':
        return { ...state, saving: false, error: null};
      case 'UPDATE_PEI_STATUS_FAIL':
        return { ...state, saving: false, error: action.payload };

      case 'SAVE_PEI_OBJECTIVES_REQUEST':
        return { ...state, objectives: { saving: true, error: null },};
      case 'SAVE_PEI_OBJECTIVES_SUCCESS':
        return { ...state, objectives: { saving: false, error: null },};
      case 'SAVE_PEI_OBJECTIVES_FAIL':
        return { ...state, objectives: { saving: false, error: action.payload },};
      
      case 'DELETE_PEI_REQUEST':
        return { ...state, deletingId: action.payload, error: null };
      case 'DELETE_PEI_SUCCESS': {
        const removedId = action.payload;
        return {
          ...state,
          deletingId: null,
          error: null,
          data: state.data.filter(p =>
            (p.id ?? p.Id) !== removedId
          )
        };
      }
      case 'DELETE_PEI_FAIL':
        return { ...state, error: action.payload };

      case 'LOAD_MATRIX_REQUEST':
        return { ...state, matrix: { ...state.matrix, loading: true, error: null },};
      case 'LOAD_MATRIX_SUCCESS':
        return { ...state, matrix: { ...state.matrix, loading: false, data: action.payload, error: null },};
      case 'LOAD_MATRIX_FAIL':
        return { ...state, matrix: { ...state.matrix, loading: false, error: action.payload },};

      case 'LOAD_MATRIX_PEI_REQUEST':
        return { ...state, matrixPei: { ...state.matrixPei, loading: true, error: null },};
      case 'LOAD_MATRIX_PEI_SUCCESS':
        return { ...state, matrixPei: { ...state.matrixPei, loading: false, data: action.payload, error: null },};
      case 'LOAD_MATRIX_PEI_FAIL':
        return { ...state, matrixPei: { ...state.matrixPei, loading: false, error: action.payload },};
  
      case 'PROCESS_CHANGED_CLEAR_STATE':
        return { ...initialState };

      default:
        return state;
    }
  };
    
  export default peiReducer;
    